import styled from "styled-components";

export const WeatherCard = styled.div`
  widows: 160px;
  height: 110px;
  display: flex;
  flex-direction: column;
  margin-left: 5px;
`;

export const CardBody = styled.div`
  display: flex;
`;

export const Temperature = styled.span`
  font-weight: 600;
  font-size: 80px;
  line-height: 98px;
  text-transform: uppercase;
  z-index: 2;
`;

export const Day = styled.span`
  line-height: 27px;
  text-transform: uppercase;
`;
export const WeatherImg = styled.img`
  height: 70px;
  position: relative;
  left: -10px;
  object-fit: contain;
`;
